import { Route } from "react-router";
import * as MyApps from "./Routes";
import "./shared/css/Form.css";

const AppOutlet = [
  <Route
    path="/app/find-resolution"
    component={MyApps.FindResolutionApp}
    exact
    key="route-1"
    />,
    <Route
    path="/app/find-aspect-ratio"
    component={MyApps.FindAspectRatioApp}
    exact
    key="route-2"
    />,
    <Route
    path="/app/custom-aspect-ratio"
    component={MyApps.CustomAspectRatioApp}
    exact
    key="route-3"
  />
]

export default AppOutlet;
